import { combineReducers } from "redux"
import Reducer from "./userReducer"

const rootReducer = combineReducers({
  Reducer
})

export default rootReducer
